




import LoginComponent from "@/components/loginComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LoginPage",
  components: {
    LoginComponent,
  },
})
export default class LoginPage extends Vue {}
